import { useQuery } from "@tanstack/react-query";
import { chatService } from "../services";
import { customKeys } from "@/lib/queryKeyFactory";

const THREADS_STALE_TIME = 30 * 1000;

/**
 * Hook to fetch the caller's chat threads.
 * Kept fresh by inbox-bump invalidation from the WebSocket layer.
 */
export function useChatThreads() {
  return useQuery({
    queryKey: customKeys.chat.threads(),
    queryFn: () => chatService.getThreads(),
    staleTime: THREADS_STALE_TIME,
  });
}

/**
 * Hook to fetch a single thread
 */
export function useChatThread(threadId: string) {
  return useQuery({
    queryKey: customKeys.chat.thread(threadId),
    queryFn: () => chatService.getThread(threadId),
    enabled: !!threadId,
  });
}

/**
 * Total unread messages across all threads — derived from the threads cache,
 * used for the sidebar badge.
 */
export function useChatUnreadCount(): number {
  const { data: threads } = useChatThreads();
  return threads?.reduce((sum, t) => sum + t.unreadCount, 0) ?? 0;
}
